<template>
  <mdb-container>
    <mdb-row>
      <mdb-col col="4">
        <mdb-date-picker-2
          inline
          v-model="localDate"
          :options="options"
          :label="$t('report_newsletter_datepicker_title')"
        />
      </mdb-col>
      <mdb-col col="4">
        <mdb-btn color="indigo" @click="startUserNewsLetterReportGeneration">{{
          $t("report_newsletter_extract_data")
        }}</mdb-btn>
      </mdb-col>
    </mdb-row>
  </mdb-container>
</template>

<script>
import { mdbBtn, mdbContainer, mdbCol, mdbRow, mdbDatePicker2 } from "mdbvue";
export default {
  name: "ReportNewsLetterGeneration",
  components: {
    mdbBtn,
    mdbContainer,
    mdbCol,
    mdbRow,
    mdbDatePicker2
  },
  data() {
    return {
      localDate: "2020-01-01",
      customers: null,
      retrievebypath: "/1.0/front/customer/report/newsletter/",
      optionsCSV: {
      delimiter: {
        field: ";" // Comma field delimiter
      }
    },
    };
  },
  methods: {
    startUserNewsLetterReportGeneration() {
      this.fetchUserNewsLetterData();
    },
    fetchUserNewsLetterData() {
      this.$http
        .get(this.retrievebypath + this.localDate)
        .then(response => {
          if (response.status == 200) {
            this.customers = response.data.customers;
            this.createCSV(this.customers, this.optionsCSV, "newslettercustomers.csv")
          } else if (response.status == 401) {
            this.$root.$emit("session_failed");
          }
        })
        .catch(error => {
          return error;
        });
    }
  }
};
</script>

<style scoped></style>
